<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Procesamiento" key="1">
        <a-row :gutter="[16,16]">
          <a-col :xs="24" :sm="24" :md="24">
            <a-card>
              <a-spin :spinning="loading">
                <a-form-model :model="processData" :rules="rules" ref="processForm">
                  <a-row :gutter="[5,5]">
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Compañía')" prop="id_company">
                        <form-model-dropdown style="width: 100%"
                                             endpoint="company"
                                             v-model="processData.id_company"
                        >
                        </form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Año')" prop="year">
                        <a-input-number style="width: 100%;"
                                        step="1"
                                        v-model="processData.year">
                        </a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Mes')" prop="month">
                        <a-input-number style="width: 100%;"
                                        step="1"
                                        v-model="processData.month">
                        </a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Periodo')" prop="periodo">
                        <form-model-dropdown style="width: 100%"
                                             v-model="processData.periodo"
                                             endpoint="hierarchy_lookup"
                                             :params="period_request"
                        ></form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Proceso')" prop="proceso">
                        <form-model-dropdown style="width: 100%"
                                             v-model="processData.proceso"
                                             endpoint="hierarchy_lookup"
                                             :selectedObj.sync="procesoSeleccionado"
                                             :params="proceso_request"
                        ></form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Fecha Inicio')" prop="fecha_inicio">
                        <a-date-picker
                          v-model="processData.fecha_inicio"
                          type="date"
                          style="width: 100%;"
                          valueFormat="Y-MM-DD HH:mm:ss"
                          :disabled="fechasDesactivadas"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Fecha Fin')" prop="fecha_fin">
                        <a-date-picker
                          v-model="processData.fecha_fin"
                          type="date"
                          style="width: 100%;"
                          valueFormat="Y-MM-DD HH:mm:ss"
                          :disabled="fechasDesactivadas"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Localidad')" prop="localidad_id" has-feedback>
                        <form-model-dropdown style="width: 100%"
                                             endpoint="offices"
                                             v-model="processData.localidad_id">
                        </form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Tipo Pago')" prop="tipo_pago">
                        <form-model-dropdown style="width: 100%"
                                             v-model="processData.tipo_pago"
                                             endpoint="hierarchy_lookup"
                                             :params="tipo_pago_request"
                        ></form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Fecha Pago')" prop="fecha_pago">
                        <a-date-picker
                          v-model="processData.fecha_pago"
                          type="date"
                          style="width: 100%;"
                          valueFormat="Y-MM-DD HH:mm:ss"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Tipo Liquidacion')" prop="tipo_liquidacion">
                        <form-model-dropdown style="width: 100%"
                                             v-model="processData.tipo_liquidacion"
                                             endpoint="hierarchy_lookup"
                                             :params="tipo_liq_request"
                        ></form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Empleado')" prop="id_emp">
                        <form-model-lookup style="width: 100%"
                                           endpoint="empleados"
                                           v-model="processData.id_emp"
                                           :params="empleado_params"
                                           :selectedObj.sync="empleadoSeleccionado"
                                           :cache="false">
                        </form-model-lookup>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Cliente')" prop="cliente">
                        <form-model-dropdown style="width: 100%"
                                             endpoint="customer"
                                             v-model="processData.cliente"
                        >
                        </form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Contrato')" prop="contrato">
                        <form-model-dropdown style="width: 100%"
                                             endpoint="customer_contracts"
                                             v-model="processData.contrato"
                        >
                        </form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Mision/Planta')" prop="categoria">
                        <form-model-dropdown style="width: 100%"
                                             v-model="processData.categoria"
                                             endpoint="hierarchy_lookup"
                                             :params="{h_lookup_type: 'CATEGORIA'}"
                        ></form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <a-form-model-item :label="$t('Opcionales')" prop="opcionales">
                        <form-model-dropdown style="width: 100%"
                                             endpoint="hierarchy_lookup"
                                             v-model="processData.opcionales"
                                             :params="{h_lookup_type: 'PROCESAMIENTO_OPCIONES', use_code: true}"
                        >
                        </form-model-dropdown>
                      </a-form-model-item>
                    </a-col>
                    <div v-if="processData.id_emp && empleadoSeleccionado.id_person">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Identificación')" has-feedback>
                          <a-input :disabled="true" style="width: 100%"
                                   v-model="empleadoSeleccionado.id_person"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Cargo')" prop="name1" has-feedback>
                          <a-input :disabled="true" style="width: 100%"
                                   v-model="empleadoSeleccionado.cargo"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha ingreso')" prop="name1" has-feedback>
                          <a-input :disabled="true" style="width: 100%"
                                   v-model="empleadoSeleccionado.initial_date_desc"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha retiro')" prop="name1" has-feedback>
                          <a-input :disabled="true" style="width: 100%"
                                   v-model="empleadoSeleccionado.termination_date_desc"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Sueldo')" prop="name1" has-feedback>
                          <a-input-number :disabled="true" style="width: 100%"
                                          :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                          :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                                          v-model="empleadoSeleccionado.salary"></a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Estado')" prop="name1" has-feedback>
                          <a-input :disabled="true" style="width: 100%"
                                   v-model="empleadoSeleccionado.status_desc"></a-input>
                        </a-form-model-item>
                      </a-col>
                    </div>
                    <a-col :span="18">
                      <a-row style="text-align: right; padding-top: 40px; margin-top: 2px">
                        <a-button icon="search" :disabled="!processData.id_emp" @click="abrirAcumulador">
                          Acumulado colaborador
                        </a-button>
                        <a-button type="primary" :disabled="validaExcel"
                                  style="background-color: rgb(29, 111, 66); color: white"
                                  :loading="buttonExcelLoadingPrenomina"
                                  class="header-btn"
                                  icon="file-excel" @click="exportarExcel('nomina_abierta')">
                          Prenomina
                        </a-button>
                        <a-button
                          type="primary"
                          :disabled="validaExcel"
                          style="background-color: rgb(29, 111, 66); color: white"
                          :loading="buttonExcelLoadingDefinitiva"
                          class="header-btn"
                          icon="file-excel" @click="exportarExcel('nomina_cerrada')">
                          Nomina definitiva
                        </a-button>
                        <a-button type="primary" @click="ejecutar('procesar')">
                          Procesar
                        </a-button>
                        <a-button style="background-color: #a9b52f; color: white; border-color: #a9b52f;"
                                  @click="ejecutar('reversar')">
                          Reversar
                        </a-button>
                        <a-button v-if="ocultarToNovelty" type="danger" @click="ejecutar('cerrar')">
                          Cerrar
                        </a-button>
                      </a-row>
                    </a-col>
                  </a-row>
                  <div v-if="processStatus.proceso">
                    <div>&nbsp;</div>
                    <a-alert
                      message="En ejecución."
                      description="Se está ejecutando el proceso solicitado. Por favor espere..."
                      type="info"
                      show-icon
                      v-if="graphStatus === 'normal'"
                    />
                    <a-alert
                      message="Error."
                      :description="`El proceso ha fallado, con mensaje: ${processStatus.mensaje}`"
                      type="error"
                      show-icon
                      v-if="graphStatus === 'exception'"
                    />
                    <a-alert
                      message="Finalizado."
                      :description="`El proceso ha finalizado correctamente, mensaje: ${processStatus.mensaje}.`"
                      type="success"
                      show-icon
                      v-if="graphStatus === 'success'"
                    />
                  </div>
                </a-form-model>
              </a-spin>
            </a-card>
          </a-col>
        </a-row>
        <a-modal title="Confirmación"
                 :visible="confirmModalVisible"
                 :confirmLoading="confirmModalLoading"
                 :closable="!confirmModalLoading"
                 @ok="confirmarProceso"
                 @cancel="cancelarProceso"
                 :okText="procesoAejecutar === 'cerrar' ? 'Cerrar' : (procesoAejecutar === 'reversar' ? 'Reversar' : 'Procesar' )"
                 cancelText="Cancelar"
                 width="50%">
          <a-result
            :status="procesoAejecutar === 'cerrar' ? 'warning' : 'info'"
            title="Advertencia"
            sub-title="Tenga en cuenta que solo puede tener un proceso ejecutándose de manera simultanea."
            style="padding: 5px 32px;">
            <div class="desc">
              <p style="font-size: 16px;">
                <strong>Consideraciones antes de realizar este proceso:</strong>
              </p>
              <p v-for="tip in consideraciones.cerrar" v-if="procesoAejecutar === 'cerrar'">
                <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
                {{tip}}
              </p>
              <p v-for="tip in consideraciones.procesar" v-if="procesoAejecutar === 'procesar'">
                <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
                {{tip}}
              </p>
              <p v-for="tip in consideraciones.reversar" v-if="procesoAejecutar === 'reversar'">
                <a-icon :style="{ color: 'orange' }" type="exclamation-circle"/>
                {{tip}}
              </p>
            </div>
          </a-result>
          <a-alert v-if="confirmModalError" :message="confirmModalError" type="error" show-icon/>
        </a-modal>
        <a-modal title="Acumulado Colaborador"
                 :visible="modalAcumulado.visible"
                 @ok="okAcumulado"
                 :width="'90%'"
                 @cancel="cancelAcumulado">
          <a-form-model :model="acumuladoForm" :rules="rulesFilterAcum" ref="processFormAcum">
            <a-row :gutter="[5,5]">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Año')" prop="full_date">
                  <a-range-picker :placeholder="['Desde el mes', 'Hasta el mes']" :mode="mode"
                                  :value="acumuladoForm.full_date"
                                  @panelChange="handlePanelChange"
                                  format="YYYY-MM" v-model="acumuladoForm.full_date"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan" style="padding-top: 40px; margin-top: 7px">
                <a-button v-if="ocultarToNovelty" type="primary" icon="search" @click="filtrarAcumulado()">
                  Filtrar
                </a-button>
              </a-col>
            </a-row>
          </a-form-model>
          <div v-if="acumuladoForm.full_date.length > 0 && filterParamsNominaCerrada.full_date.length > 0">
            <g-master :name="masterNominaCerrada.endpoint"
                      :endpoint="masterNominaCerrada.endpoint"
                      :actions="false"
                      :tableSetup="masterNominaCerrada.tableSetup"
                      :parentData="filterParamsNominaCerrada"
                      ref="masterNominaCerrada"
                      modalWidth="100%"
                      :key="key"
            >
            </g-master>
            <br>
            <a-tag color="orange">
              <center>Valor neto total: <br><b>{{sumaTotal(masterNominaCerrada.tableSetup.selectedRows)}}</b>
              </center>
            </a-tag>
          </div>
          <a-alert v-else
                   message="Nota informativa"
                   description="Para visualizar información por favor ingrese una fecha válida"
                   type="info"
                   show-icon
          />

        </a-modal>
      </a-tab-pane>
    </a-tabs>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Movimientos" key="1">
        <g-master :name="masterNominaAbierta.endpoint"
                  :endpoint="masterNominaAbierta.endpoint"
                  :actions="false"
                  :tableSetup="masterNominaAbierta.tableSetup"
                  :parentData="filterParamsNominaAbierta"
                  ref="parentDataNominaAbierta"
                  modalWidth="70%"
                  :key="keyAbierto"
        >
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        buttonExcelLoadingPrenomina: false,
        buttonExcelLoadingDefinitiva: false,
        yearToday: parseInt(moment().format('YYYY')),
        acumuladoForm: {
          full_date: []
        },
        mode: ['month', 'month'],
        key: 0,
        keyAbierto: 0,
        endpointExcel: 'payroll_nomina/exportExcelAcumulados',
        fileNameExcelNCerrada: 'nominaCerrada',
        empleadoSeleccionado: {
          id_person: null,
          cargo: null,
          initial_date_desc: null,
          termination_date_desc: null,
          salary: null,
          status_desc: null
        },
        colSpan: {
          xs: 24,
          md: 6
        },
        period_request: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        proceso_request: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        tipo_liq_request: {
          h_lookup_type: 'TIPO_LIQUIDACION',
          use_code: true
        },
        tipo_pago_request: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        processStatus: {
          loading: false,
          status: 'RUNNING', // RUNNING FAILED FINISHED
          procesados: 0,
          procesados_percent: 0,
          pendientes: 0,
          pendientes_percent: 0,
          total: 0,
          porcent: 0,
          proceso: false,
          mensaje: ''
        },
        processData: {
          id_emp: null,
          id_company: null,
          tipo_pago: null,
          tipo_liquidacion: null,
          localidad_id: null,
          year: null,
          month: null,
          periodo: null,
          fecha_inicio: null,
          fecha_fin: null,
          contrato: null,
          categoria: null,
          cliente: null,
          opcionales: null
        },
        fechasDesactivadas: false,
        consultaFechasLastRequest: null,
        consultaFechaTimeout: null,
        fechasRequestCount: 0,
        procesoSeleccionado: {},
        rulesFilterAcum: {
          full_date: [{required: true, message: 'Valor requerido'}]
        },
        rules: {
          id_company: [{required: true, message: 'Valor requerido'}],
          year: [{required: true, message: 'Valor requerido'}],
          month: [{required: true, message: 'Valor requerido'}],
          periodo: [{required: true, message: 'Valor requerido'}],
          fecha_inicio: [{required: true, message: 'Valor requerido'}],
          fecha_fin: [{required: true, message: 'Valor requerido'}],
          proceso: [{required: true, message: 'Valor requerido'}]
        },
        procesoAejecutar: null,
        confirmModalVisible: false,
        confirmModalLoading: false,
        confirmModalError: false,
        consideraciones: {
          cerrar: [
            'Este proceso no puede ser reversado',
            'Solo puede tener un proceso de cierre ejecutandose simultaneamente'
          ],
          procesar: [
            'Solo puede tener un proceso ejecutandose simultaneamente'
          ],
          reversar: [
            'Solo puede tener un proceso ejecutandose simultaneamente',
            'Solo es posible reversar una vez haya terminado la ejecución del proceso'
          ]
        },
        updateGraphTimeout: null,
        loading: false,
        initialPayrollParameter: false,
        modalAcumulado: {
          visible: false
        },
        masterNominaCerrada: {
          endpoint: 'payroll',
          tableSetup: {
            allowSelect: true,
            selectType: 'checkbox',
            selectedRows: [],
            actions: false,
            tableConfig: {
              rowKey: 'id',
              scroll: {x: 3500, y: 300},
              pagination: {
                pageSize: 500,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['600', '700', '900'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_disp', sorter: true, width: 400},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Vlr base', dataIndex: 'base', sorter: true},
              {title: 'Vlr de deducción', dataIndex: 'amountded', sorter: true},
              {title: 'Vlr de devengo', dataIndex: 'amountdev', sorter: true},
              {title: 'Vlr neto', dataIndex: 'net', sorter: true}
            ]
          }
        },
        filterParamsNominaCerrada: {
          full_date: [],
          employee: null,
          filter_parent_consulta_nomina_cerrada: true
        },
        masterNominaAbierta: {
          endpoint: 'payroll',
          tableSetup: {
            customSlots: ['fechaRenderer'],
            actions: false,
            allowSelect: false,
            tableConfig: {
              rowKey: 'id',
              scroll: {x: 3500, y: 300},
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true, width: 400},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Vlr base', dataIndex: 'base', sorter: true},
              {title: 'Vlr de deducción', dataIndex: 'amountded', sorter: true},
              {title: 'Vlr de devengo', dataIndex: 'amountdev', sorter: true},
              {title: 'Vlr neto', dataIndex: 'net', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.getPayrollParameter()
      this.updateGraphTimeout = setTimeout(this.consultaEstado, 1000)
    },
    beforeDestroy () {
      this.updateGraphTimeout && clearTimeout(this.updateGraphTimeout)
    },
    methods: {
      sumaTotal (arreglo) {
        var suma = 0

        arreglo.forEach(objeto => {
          suma += parseFloat(objeto.net)
        })
        return suma.toLocaleString('es-CO', {style: 'currency', currency: 'COP'})
      },
      handlePanelChange (value, mode) {
        this.acumuladoForm.full_date = value
        this.mode = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
      },
      async exportarExcel (proceso) {
        const loadingKey = proceso === 'nomina_abierta'
          ? 'buttonExcelLoadingPrenomina'
          : 'buttonExcelLoadingDefinitiva'
        this[loadingKey] = true
        try {
          const response = await this.httpClient.getInstance().get(this.endpointExcel, {
            params: {
              prc: this.processData.proceso,
              month: this.processData.month,
              period: this.processData.periodo,
              year: this.processData.year,
              company: this.processData.id_company,
              nomina: proceso
            },
            responseType: 'arraybuffer'
          })
          const blob = new Blob([response.data], {type: response.headers['content-type']})
          const fileURL = window.URL.createObjectURL(blob)

          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.download = `${this.fileName}.xlsx`
          document.body.appendChild(fileLink)
          fileLink.click()
          window.URL.revokeObjectURL(fileURL)
          fileLink.remove()

          Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
        } catch (error) {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        } finally {
          this[loadingKey] = false
        }
      },

      filtrarAcumulado () {
        this.$refs.processFormAcum && this.$refs.processFormAcum.validate(valid => {
          if (!valid) return
          this.filterParamsNominaCerrada.full_date = this.acumuladoForm.full_date
          this.masterNominaCerrada.tableSetup.actions = false
          this.key++
        })
      },
      okAcumulado () {
        this.modalAcumulado.visible = false
      },
      cancelAcumulado () {
        this.modalAcumulado.visible = false
      },
      abrirAcumulador () {
        this.acumuladoForm.full_date = []
        this.filterParamsNominaCerrada.full_date = []
        this.filterParamsNominaCerrada.employee = this.processData.id_emp
        this.masterNominaCerrada.tableSetup.actions = false
        this.key++
        this.modalAcumulado.visible = true
      },
      limpiarEmpleado () {
        this.processData.id_emp = null
      },
      procesarAnoMesPeriodo (requestNumber) {
        if (this.initialPayrollParameter) {
          return
        }
        this.processData.fecha_inicio = null
        this.processData.fecha_fin = null

        if (!JsUtils.isEmpty(this.processData.year) && !JsUtils.isEmpty(this.processData.month) && !JsUtils.isEmpty(this.processData.periodo)) {
          this.fechasDesactivadas = true
          try {
            this.consultaFechasLastRequest && this.consultaFechasLastRequest.cancel()
          } catch (e) {
          }
          this.consultaFechasLastRequest = this.httpClient.getInstance().get('procesamiento/consulta_payroll_callendar', {
            params: {
              year: this.processData.year,
              month: this.processData.month,
              periodo: this.processData.periodo
            }
          }).then((response) => {
            if (this.fechasRequestCount === requestNumber) {
              this.processData.fecha_inicio = moment(response.data.dtini).format('Y-MM-DD HH:mm:ss')
              this.processData.fecha_fin = moment(response.data.dtend).format('Y-MM-DD HH:mm:ss')
            }
          }).catch(() => {
            if (this.fechasRequestCount === requestNumber) {
              Mensajes.warning('Advertencia', 'No hay un calendario de pagos configurado para el año/mes seleccionado.')
            }
          }).then(() => {
            if (this.fechasRequestCount === requestNumber) {
              this.fechasDesactivadas = false
            }
          })
        }
      },
      ejecutar (proceso) {
        this.$refs.processForm && this.$refs.processForm.validate(valid => {
          if (!valid) return
          if (this.processData.proceso === '1' && this.processData.periodo === '4') {
            let ff = this.processData.fecha_fin
            if (!moment.isMoment(ff)) {
              ff = moment(this.processData.fecha_fin)
            }
            let endOfMonth = ff.clone().endOf('month')
            if (endOfMonth.date() !== ff.date()) {
              Mensajes.warning('Verificar', 'Cuando se realiza el proceso de liquidación mensual la fecha final debe ser el último día del mes.')
              return
            }
          }
          this.procesoAejecutar = proceso
          this.confirmModalVisible = true
        })
      },
      confirmarProceso () {
        this.confirmModalLoading = true
        this.confirmModalError = false
        this.httpClient.getInstance().post('procesamiento/ejecutar_proceso_acumuluado/' + this.procesoAejecutar, this.processData)
          .then(response => {
            Mensajes.success('Correcto', 'Proceso programado satisfactoriamente')
            this.confirmModalVisible = false
            this.updateGraphTimeout = setTimeout(this.consultaEstado, 3000)
            // TODO ACTUALIZAR LA TABLA DEL DETALLE
          })
          .catch(error => {
            this.confirmModalError = this.$getErrorMessage(error, 'Error inesperado, contacte al administrador')
          })
          .then(() => {
            this.confirmModalLoading = false
          })
      },
      cancelarProceso () {
        if (this.confirmModalLoading) {
          return
        }
        this.procesoAejecutar = null
        this.confirmModalVisible = false
        this.confirmModalLoading = false
      },
      consultaEstado () {
        this.processStatus.loading = true
        this.httpClient.getInstance().get('procesamiento/consulta_estado')
          .then((response) => {
            this.processStatus.proceso = response.data.proceso
            if (this.processStatus.proceso) {
              this.processStatus.total = response.data.total
              this.processStatus.total_percent = 100
              this.processStatus.procesados = response.data.procesados
              this.processStatus.pendientes = response.data.pendientes
              this.processStatus.mensaje = response.data.mensaje

              this.processStatus.procesados_percent = parseInt(parseInt(response.data.procesados) / parseInt(response.data.total) * 100)
              this.processStatus.pendientes_percent = parseInt(parseInt(response.data.pendientes) / parseInt(response.data.total) * 100)

              this.processStatus.status = response.data.status
              this.processStatus.porcent = this.processStatus.procesados_percent

              if (this.processStatus.status === 'RUNNING') {
                this.updateGraphTimeout = setTimeout(this.consultaEstado, 3000)
              }
            }
          })
          .catch(() => {
            this.processStatus.total = 0
            this.processStatus.procesados = 0
            this.processStatus.pendientes = 0
            this.processStatus.status = 0
            this.processStatus.porcent = 0
            this.processStatus.proceso = false
          })
          .then(() => {
            this.processStatus.loading = false
          })
      },
      getPayrollParameter () {
        this.initialPayrollParameter = true
        this.loading = true
        this.httpClient.getInstance().get('procesamiento/payroll_parameter')
          .then((response) => {
            if (!this.$isEmpty(response.data)) {
              this.processData = {
                id_company: response.data.company,
                year: response.data.year,
                month: response.data.month,
                periodo: response.data.period,
                proceso: response.data.prc,
                fecha_inicio: response.data.dtini,
                fecha_fin: response.data.dtend,
                localidad_id: response.data.location,
                tipo_pago: response.data.tpay,
                fecha_pago: response.data.dtpay,
                tipo_liquidacion: response.data.tliq,
                id_emp: response.data.empid
              }
            }
          })
          .catch((error) => {
            Mensajes.error(this.$getErrorMessage(error, 'Error inesperado. Consulte al administrador.'))
          })
          .then(() => {
            this.loading = false
            this.initialPayrollParameter = false
          })
      }
    },
    watch: {
      'processData.id_company': function () {
        this.limpiarEmpleado()
      },
      'processData.tipo_pago': function () {
        this.limpiarEmpleado()
      },
      'processData.tipo_liquidacion': function () {
        this.limpiarEmpleado()
      },
      'processData.localidad_id': function () {
        this.limpiarEmpleado()
      },
      'processData.year': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      },
      'processData.month': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      },
      'processData.periodo': function () {
        if (this.initialPayrollParameter) {
          return
        }
        this.consultaFechaTimeout && clearTimeout(this.consultaFechaTimeout)
        let cnt = ++this.fechasRequestCount
        this.consultaFechaTimeout = setTimeout(() => {
          this.procesarAnoMesPeriodo(cnt)
        }, 300)
      }
    },
    computed: {
      filterParamsNominaAbierta () {
        return {
          month: null,
          year: null,
          employee: null,
          filter_parent_consulta_nomina_abierta: true,
          created_by: this.$store.state.userInfo.name
        }
      },
      validaExcel () {
        return this.processData.proceso == null || this.processData.month == null || this.processData.periodo == null
          || this.processData.year == null || this.processData.id_company == null
      },
      graphStatus () {
        if (!this.processStatus.proceso) {
          return ''
        }
        switch (this.processStatus.status) {
          case 'RUNNING':
            return 'normal'
          case 'FAILED':
            return 'exception'
          case 'FINISHED':
            return 'success'
        }
        return ''
      },
      empleado_params () {
        let result = {
          estado: 'N'
        }

        let paramsToCheck = [
          'id_company',
          'tipo_pago',
          'tipo_liquidacion',
          'localidad_id'
        ]
        if (this.procesoSeleccionado.hasOwnProperty('text') && this.procesoSeleccionado.text.includes('RELIQUIDACION DEFINITIVA')) {
          result['estado'] = 'R'
        }

        if (this.$getConfigValue('PROCESAR_PRV_SSO_EMPLEADOS_RETIRADOS') === 'SI') {
          if (this.procesoSeleccionado.hasOwnProperty('text') &&
            (this.procesoSeleccionado.text.includes('PROVISIONES') || this.procesoSeleccionado.text.includes('SEGURIDAD SOCIAL'))) {
            return {
              empleados_prv_sso: true,
              year: this.processData.year,
              mes: this.processData.month
            }
          }
        }

        paramsToCheck.map(param => {
          if (!JsUtils.isEmpty(this.processData[param])) {
            result[param] = this.processData[param]
          }
        })

        return result
      },
      ocultarToNovelty () {
        if (this.$userIsInrol('Novelty')) {
          return this.$getConfigValue('OCULTAR_BTN_CERRAR_PROCESAMIENTO', 'NO') === 'NO'
        }
        return true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Procesamiento/ProcesamientoTemporales.vue